<template>
  <div class="scene" id="scene-4">
    <ImageFloat
      id="booklet"
      class="booklet"
      :class="{
        'fix-me': activeElements['booklet'] === 'fixed',
        'end': activeElements['booklet'] === 'end'
      }"
    />
    <div id="trigger-9-1" class="triggers"></div>
    <Why
      id="why-mock"
      class="why"
      :class="{
        'fix-me': activeElements['why-mock'] === 'fixed',
        'end': activeElements['why-mock'] === 'end'
      }"
    />
    <div id="trigger-9-2" class="triggers"></div>
    <div id="trigger-9" class="triggers"></div>
    <div id="trigger-10" class="triggers"></div>
  </div>
</template>

<script>
import ImageFloat from '@/components/ImageFloat.vue'
import strings from '@/data/strings.json'
import Why from '@/components/Why.vue'
import senseScroll from '@/utils/senseScroll.js'

export default {
  name: 'SceneFour',
  data () {
    return {
      page: {},
      inside: false,
      strings: strings,
      directives: [
        {
          id: 'why-mock',
          start: 'scene-4',
          end: 'trigger-9'
        }
      ]
    }
  },
  props: {
    scrollPos: Number
  },
  computed: {
    activeElements () {
      return senseScroll(this.directives, this.scrollPos)
    }
  },
  methods: {
  },
  mounted () {
  },
  components: {
    ImageFloat,
    Why
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  #scene-4 {
    height: 180vh;
    position: relative;
    @media only screen and (max-height: 720px) {
      height: 190vh;
    }
    @media only screen and (max-height: 670px) {
      height: 200vh;
    }
  }
  .ani {
    opacity: 1;
    transition: opacity 0.2s ease;
    &.fix-me, &.end {
      opacity: 1;
    }
  }
  #booklet {
    position: absolute;
    width: 100%;
    height: 100vh;
    top: 0px;
    z-index: 99;
  }
  #why-mock {
    position: absolute;
    width: 100%;
    height: 100vh;
    top: 0vh;
  }
  #trigger-9-1 {
    position: absolute;
    width: 100%;
    height: 100vh;
    top: 65vh;
  }
  #trigger-9-2 {
    position: absolute;
    width: 100%;
    height: 100vh;
    top: 145vh;
  }
  #why-mock.end {
    position: absolute;
    top: 135vh;
    @media only screen and (orientation: portrait) {
      top: 155vh;
    }
  }
  #why-p {
    position: relative;
    top: 100vh;
    width: 100%;
  }
  #booklet.end {
    position: absolute;
    top: 145vh;
  }
  #trigger-9 {
    position: absolute;
    top: 135vh;
    @media only screen and (orientation: portrait) {
      top: 155vh;
    }
  }
  #why-texts {
    top: 200vh;
    width: 100%;
    position: absolute;
  }
  .fix-me {
    top: 0px !important;
    position: fixed !important;
  }
  .triggers {
    position: absolute;
    height: 100vh;
    width: 100%;
  }
</style>
